var map = {
	"./arrow": 1467,
	"./arrow.svg": 1467,
	"./article": 1468,
	"./article.jpg": 1468,
	"./artm": 1469,
	"./artm.jpg": 1469,
	"./buy-1": 1470,
	"./buy-1.png": 1470,
	"./buy-2": 1471,
	"./buy-2.png": 1471,
	"./buy-3": 1472,
	"./buy-3.png": 1472,
	"./buy-4": 1473,
	"./buy-4.png": 1473,
	"./buy-5": 1474,
	"./buy-5.png": 1474,
	"./hero": 1475,
	"./hero-logo": 1476,
	"./hero-logo.svg": 1476,
	"./hero-text": 1477,
	"./hero-text.svg": 1477,
	"./hero.jpg": 1475,
	"./herom": 1478,
	"./herom.jpg": 1478,
	"./icons/i-1": 31,
	"./icons/i-1.png": 31,
	"./icons/i-1.svg": 2286,
	"./icons/i-2": 1479,
	"./icons/i-2.svg": 1479,
	"./icons/i-3": 1480,
	"./icons/i-3.svg": 1480,
	"./icons/i-4": 1481,
	"./icons/i-4.svg": 1481,
	"./icons/i-5": 1482,
	"./icons/i-5.svg": 1482,
	"./icons/i-6": 1483,
	"./icons/i-6.svg": 1483,
	"./knife": 1484,
	"./knife.png": 1484,
	"./logo": 1485,
	"./logo.svg": 1485,
	"./machine": 1486,
	"./machine-d": 1487,
	"./machine-d.png": 1487,
	"./machine.png": 1486,
	"./mobbg": 1488,
	"./mobbg.png": 1488,
	"./play": 1489,
	"./play.svg": 1489,
	"./recbg": 1490,
	"./recbg.png": 1490,
	"./recipe": 1491,
	"./recipe.jpg": 1491,
	"./recipes/rec-1-min": 1492,
	"./recipes/rec-1-min.jpg": 1492,
	"./recipes/rec-2-min": 1493,
	"./recipes/rec-2-min.jpg": 1493,
	"./recipes/rec-3-min": 1494,
	"./recipes/rec-3-min.jpg": 1494,
	"./recipes/rec-4-min": 1495,
	"./recipes/rec-4-min.jpg": 1495,
	"./recipes/rec-5-min": 1496,
	"./recipes/rec-5-min.jpg": 1496,
	"./roll": 1497,
	"./roll.png": 1497,
	"./soc-1": 1498,
	"./soc-1.svg": 1498,
	"./soc-2": 1499,
	"./soc-2.svg": 1499,
	"./soc-3": 1500,
	"./soc-3.svg": 1500,
	"./test": 1501,
	"./test.jpg": 1501,
	"./testm": 1502,
	"./testm.jpg": 1502,
	"./thumb": 1503,
	"./thumb.svg": 1503,
	"./video": 1504,
	"./video.jpg": 1504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2285;